module.exports = __webpack_public_path__ + "img/icon_popup_playlist_add.4c573647.svg";